import { productionOrderStates as states } from '../Config/productionOrderStates';
import flagstoneTheme from '../Config/flagstoneTheme';
import { SchedulerData } from 'flagstone-scheduler';

export function setSchedularData(workstations, productionOrders, actions, viewType, props) {
    let resources = []
    let activeResources = []
    var i;
    for (i = 0; i < props.workstation.activeWorkstations.length; i++) {

        activeResources.push({ id: props.workstation.activeWorkstations[i].id, name: props.workstation.activeWorkstations[i].code })

    }

    if (activeResources.length === 0) {
        activeResources = workstations
    }

    for (i = 0; i < workstations.length; i++) {
        resources.push({ id: workstations[i].id, name: workstations[i].code })
    }


    let events = getEventsFromProductionOrders(productionOrders, workstations, "", props)

    const data = { resources: resources, events: events }

    if (JSON.stringify(data) !== JSON.stringify(props.planning.data)) {
        actions.setPlanningData(data)
    }

    let schedularData = new SchedulerData(props.planning.date, viewType);
    schedularData.localeMoment.locale('en');


    schedularData.setResources(resources);


    schedularData.setEvents(events);


    schedularData.setRestrictions(props.workstation.restrictions)


    schedularData.setWorkingHours(props.workstation.workingHours)

    schedularData.setActiveResources(activeResources)

    return schedularData
}

export function getEventsFromProductionOrders(productionOrders, workstations, searchString, props) {

    let activeResources = getActiveResources(workstations, props.workstation.activeWorkstations)
    let events = []
    var y;
    for (y = 0; y < productionOrders.length; y++) {

        let bgColor = "";
        var imgSrc = "";
        let opacity = "0.7"
        if (productionOrders[y].salesOrderReference) {
            opacity = "1"
        }

        var status = productionOrders[y].productionOrderStatus;

        if (status === states.RUNNING) {
            bgColor = "rgb(92,201,88," + opacity + ")"
            imgSrc = "./img/play_white.svg"
            if (!activeResources.some(x => x.id === productionOrders[y].machineIdPlanned)) {
                bgColor = "#66b363"
            }
        }
        if (status === states.PAUSED) {
            bgColor = "rgb(245,145,40," + opacity + ")"
            imgSrc = "./img/pause_white.svg"
            if (!activeResources.some(x => x.id === productionOrders[y].machineIdPlanned)) {
                bgColor = "#d28c41"
            }
        }
        if (status === states.PLANNED) {
            bgColor = "rgb(141,141,141," + opacity + ")"

            if (!activeResources.some(x => x.id === productionOrders[y].machineIdPlanned)) {
                bgColor = "#898989"
            }
        }
        if (status === states.STOPPED) {
            bgColor = "rgb(216,73,73," + opacity + ")"
            imgSrc = "./img/stop_white.svg"
            if (!activeResources.some(x => x.id === productionOrders[y].machineIdPlanned)) {
                bgColor = "#b75b5b"
            }
        }
        if (status === states.DONE) {
            bgColor = "rgb(92,201,88," + opacity + ")"
            imgSrc = "./img/done_white.svg"
            if (!activeResources.some(x => x.id === productionOrders[y].machineIdPlanned)) {
                bgColor = "#66b363"
            }
        }

        let articlePieces = '';
        let resourceId = 0;

        if (JSON.parse(productionOrders[y].metaData).find(x => x.MetaDataType === 1).MetaData[0].Maintenance) {
            bgColor = flagstoneTheme.palette.primary.main

            if (!activeResources.some(x => x.name === String(JSON.parse(productionOrders[y].metaData).find(x => x.MetaDataType === 1).MetaData[0].MachineToMaintain))) {
                bgColor = "#5057a8"
            }
            if (productionOrders[y].productionOrderStatus === states.PLANNED) {
                bgColor = "1BBAF1"
                if (!activeResources.some(x => x.name === String(JSON.parse(productionOrders[y].metaData).find(x => x.MetaDataType === 1).MetaData[0].MachineToMaintain))) {
                    bgColor = "#50a6c4"
                }
            }
            articlePieces = JSON.parse(productionOrders[y].metaData).find(x => x.MetaDataType === 1).MetaData[0].MaintenanceDescription
            resourceId = workstations.find(x => x.code === String(JSON.parse(productionOrders[y].metaData).find(x => x.MetaDataType === 1).MetaData[0].MachineToMaintain)).id
        }
        else {

            articlePieces = String(Math.round(productionOrders[y].bomOut[0].quantityToProduce)) + " x " + productionOrders[y].bomOut[0].productReference
            resourceId = productionOrders[y].machineIdPlanned
        }

        let border = null

        if (searchString !== "") {
            if (productionOrders[y].reference.includes(searchString)) {
                border = "5px solid yellow"
            }
        }

        events.push({ id: productionOrders[y].id, start: productionOrders[y].startedOnPlanned, end: productionOrders[y].finishedOnPlanned, resourceId: resourceId, title: articlePieces, border: border, bgColor: bgColor, image: imgSrc, state: productionOrders[y].productionOrderStatus.toUpperCase() })

    }

    return events
}

export function getActiveResources(workstations, activeWorkstations) {
    let activeResources = []
    var i;
    for (i = 0; i < activeWorkstations.length; i++) {

        activeResources.push({ id: activeWorkstations[i].id, name: activeWorkstations[i].code })

    }

    if (activeResources.length === 0) {
        activeResources = workstations
    }

    return activeResources
}



